import { render } from "./RadioOption.vue?vue&type=template&id=673acff3&scoped=true&ts=true"
import script from "./RadioOption.vue?vue&type=script&lang=ts"
export * from "./RadioOption.vue?vue&type=script&lang=ts"

import "./RadioOption.vue?vue&type=style&index=0&id=673acff3&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673acff3"]])

export default __exports__